import type { Event } from '../types';
import type { ReferralSource } from '../../../types/referral_source.enum';
import type { CreditRange } from '../../../types/credit_range.enum';

export const OnboardingEventData = {
  OnboardingReceiveIdentities: {
    eventAction: 'Receive Identities',
  } as Event<''>,
  OnboardingDriverViolations: {
    eventAction: 'confirm driver violations',
  } as Event<'Display' | 'Confirm'>,
  OnboardingDateOfBirth: {
    eventAction: 'Date of Birth',
  } as Event<''>,
  OnboardingNoIDMatch: {
    eventAction: 'No ID Match',
  } as Event<''>,
  OnboardingNoAddressPrefill: {
    eventAction: 'No Addresses from sources',
  } as Event<''>,
  OnboardingAddressPrefill: {
    eventAction: 'Addresses from sources',
  } as Event<string>,
  OnboardingAddress: {
    eventAction: 'Address',
  } as Event<'Entered' | 'Selected' | 'Manual'>,
  OnboardingAddressValidate: {
    eventAction: 'Address Validate',
  } as Event<string>,
  OnboardingAddressBusiness: {
    eventAction: 'Address Business',
  } as Event<string>,
  OnboardingAnotherAddress: {
    eventAction: 'Another Address',
  } as Event<string>,
  OnboardingAnotherNewAddress: {
    eventAction: 'Another New Address',
  } as Event<string>,
  OnboardingMultipleCarsAndDrivers: {
    eventAction: 'Skip LN',
  } as Event<string>,
  OnboardingLoadingPolicy: {
    eventAction: 'Loading Policy',
  } as Event<'true' | 'false'>,
  OnboardingNoCarsPulled: {
    eventAction: 'No cars pulled',
  } as Event<string>,
  OnboardingNoDriversPulled: {
    eventAction: 'No drivers pulled',
  } as Event<string>,
  OnboardingPolicyCars: {
    eventAction: 'Vehicles',
  } as Event<string>,
  OnboardingPolicyDrivers: {
    eventAction: 'Drivers',
  } as Event<string>,
  OnboardingPolicyCoverages: {
    eventAction: 'Coverages',
  } as Event<string>,
  OnboardingAddInitialCarYear: {
    eventAction: 'Add Initial Car - Year',
  } as Event<string>,
  OnboardingAddInitialCarMake: {
    eventAction: 'Add Initial Car - Make',
  } as Event<string>,
  OnboardingAddInitialCarModel: {
    eventAction: 'Add Initial Car - Model',
  } as Event<string>,
  OnboardingAddInitialCarSubmodel: {
    eventAction: 'Add Initial Car - Submodel',
  } as Event<string>,
  OnboardingAddInitialCarMileage: {
    eventAction: 'Add Initial Car - Mileage',
  } as Event<'Viewed' | 'Selected'>,
  OnboardingAddInitialCarVin: {
    eventAction: 'Add Initial Car - Vin',
  } as Event<string>,
  OnboardingCars: {
    eventAction: 'Cars separate step',
  } as Event<''>,
  OnboardingCarsSkip: {
    eventAction: 'OnboardingCarsSkip',
  } as Event<''>,
  OnboardingCarCreated: {
    eventAction: 'CarCreated',
  } as Event<''>,
  OnboardingCarSelected: {
    eventAction: 'CarSelected',
  } as Event<'User Added' | 'Pulled'>,
  OnboardingOriginalCarsCount: {
    eventAction: 'OriginalCarsCount',
  } as Event<string>,
  OnboardingConfirmedCarsCount: {
    eventAction: 'ConfirmedCarsCount',
  } as Event<string>,
  OnboardingCarRemoved: {
    eventAction: 'RemovedCar',
  } as Event<''>,
  OnboardingGetNewSelectedCars: {
    eventAction: 'GetNewSelectedCars',
  } as Event<string>,
  OnboardingCarsEdited: {
    eventAction: 'EditedCars',
  } as Event<''>,
  OnboardingDrivers: {
    eventAction: 'Drivers separate step',
  } as Event<''>,
  OnboardingOriginalDriversCount: {
    eventAction: 'OriginalDriversCount',
  } as Event<string>,
  OnboardingLoadPolicyForSingleCarAndDriver: {
    eventAction: 'OnboardingLoadPolicyForSingleCarAndDriver',
  } as Event<string>,
  OnboardingMaritalStatusChanged: {
    eventAction: 'MaritalStatusChanged',
  } as Event<string>,
  OnboardingConfirmedDriversCount: {
    eventAction: 'ConfirmedDriversCount',
  } as Event<string>,
  OnboardingDriverRemoved: {
    eventAction: 'RemovedDriver',
  } as Event<''>,
  OnboardingDriverUpdated: {
    eventAction: 'UpdatedDriver',
  } as Event<'' | 'gender' | 'maritalStatus' | 'education' | 'driverLicenseStatus' | 'occupation'>,
  OnboardingDriversEdited: {
    eventAction: 'EditedDrivers',
  } as Event<''>,
  OnboardingOwnershipSelection: {
    eventAction: 'OnboardingOwnershipSelection',
  } as Event<'Yes' | 'No'>,
  OnboardingRefiQuestion2: {
    eventAction: 'RefiSecondaryQuestion',
  } as Event<''>,
  OnboardingRefiCarMileage: {
    eventAction: 'RefiCarMileage',
  } as Event<'Selected'>,
  OnboardingRefiQuestion2Selection: {
    eventAction: 'RefiSecondaryQuestionSelection',
  } as Event<'Yes' | 'No'>,
  OnboardingHomeowner: {
    eventAction: 'Homeowner',
  } as Event<'Yes' | 'No'>,
  OnboardingHomeownerDetailed: {
    eventAction: 'HomeownerDetailed',
  } as Event<''>,
  OnboardingEducationPrimary: {
    eventAction: 'Primary Driver Education',
  } as Event<string>,
  OnboardingEducationSpouse: {
    eventAction: 'Spouse Driver Education',
  } as Event<string>,
  OnboardingOccupationPrimary: {
    eventAction: 'Primary Driver Occupation',
  } as Event<string>,
  OnboardingOccupationPrimarySkipped: {
    eventAction: 'Primary Driver Occupation - Skipped',
  } as Event<string>,
  OnboardingOccupationSpouse: {
    eventAction: 'Spouse Driver Occupation',
  } as Event<string>,
  OnboardingOccupationSpouseSkipped: {
    eventAction: 'Spouse Driver Occupation - Skipped',
  } as Event<string>,
  OnboardingDiscountAdded: {
    eventAction: 'Added Discount',
  } as Event<string>,
  OnboardingDiscountRemoved: {
    eventAction: 'Removed Discount',
  } as Event<string>,
  OnboardingDiscountsCompleted: {
    eventAction: 'DiscountsAdded',
  } as Event<string>,
  OnboardingDiscountEducation: {
    eventAction: 'DiscountsEducation',
  } as Event<string>,
  OnboardingDiscountsOccupation: {
    eventAction: 'DiscountsOccupation',
  } as Event<string>,
  OnboardingDiscountWFHSelected: {
    eventAction: 'OnboardingDiscountWFHSelected',
  } as Event<string>,
  OnboardingDiscountsSkipped: {
    eventAction: 'DiscountsSkipped',
  } as Event<string>,
  OnboardingReferralSource: {
    eventAction: 'Referral',
  } as Event<ReferralSource>,
  OnboardingBundleOptIn: {
    eventAction: 'BundleOptIn',
  } as Event<string>,
  OnboardingPremium: {
    eventAction: 'Premium',
  } as Event<'Not Provided' | ''>,
  OnboardingPremiumSkipped: {
    eventAction: 'PremiumSkipped',
  } as Event<''>,
  OnboardingValidated: {
    eventAction: 'Validated',
  } as Event<''>,
  OnboardingWillEnterStep: {
    eventAction: 'WillEnterStep',
  } as Event<''>,
  OnboardingEnterStepFailed: {
    eventAction: 'EnterStepFailed',
  } as Event<''>,
  OnboardingSetCreditRange: {
    eventAction: 'CreditRange',
  } as Event<CreditRange>,
  OnboardingAutocompleteAddress: {
    eventAction: 'Autocomplete Address',
  } as Event<string>,
  UpdateAddress: {
    eventAction: 'Update Address',
  } as Event<string>,
  OnboardingSetDriverLicense: {
    eventAction: 'Submit Driver License Info',
  } as Event<string>,
  OnboardingDwep: {
    eventAction: 'OnboardingDwep',
  } as Event<string>,
  OnboardingGarage: {
    eventAction: 'OnboardingGarage',
  } as Event<string>,
  OnboardingCarValue: {
    eventAction: 'OnboardingCarValue',
  } as Event<string>,
  OnboardingCarValueMonthlyUpdate: {
    eventAction: 'OnboardingCarValueMonthlyUpdate',
  } as Event<string>,
  OnboardingFutureRecall: {
    eventAction: 'OnboardingFutureRecall',
  } as Event<string>,
  OnboardingSignupRecall: {
    eventAction: 'OnboardingSignupRecall',
  } as Event<string>,
  RefiOfferIntent: {
    eventAction: 'RefiOfferIntent',
  } as Event<string>,
  OnboardingAddCarByPlateVin: {
    eventAction: 'Add Car By Plate/Vin',
  } as Event<string>,
  OnboardingAddCarByPlateVinConfirm: {
    eventAction: 'Add Car By Plate/Vin Confirm',
  } as Event<string>,
  OnboardingAddCarByPlateVinFound: {
    eventAction: 'Add Car By Plate/Vin Found',
  } as Event<string>,
  OnboardingGoToAddCarByPlatVin: {
    eventAction: 'Go To Add Car By Plate/Vin',
  } as Event<string>,
  OnboardingRefiCarsSelect: {
    eventAction: 'OnboardingRefiCarsSelect',
  } as Event<string>,
  OnboardingGeicoEligible: {
    eventAction: 'GeicoEligible',
  } as Event<''>,
  OnboardingSelectCoverage: {
    eventAction: 'OnboardingSelectCoverage',
  } as Event<string>,
  NNOPromptSelection: {
    eventAction: 'NNOPromptSelection',
  } as Event<'Yes' | 'No'>,
  HouseholdVehicleSelection: {
    eventAction: 'HouseholdVehicleSelection',
  } as Event<'Yes' | 'No'>,
  NNOConfirmSelection: {
    eventAction: 'NNOConfirmSelection',
  } as Event<'Yes' | 'No'>,
  GoToNNOPrompt: {
    eventAction: 'GoToNNOPrompt',
  } as Event<string>,
  NNOIneligible: {
    eventAction: 'NNOIneligible',
  } as Event<string>,
  NNODriverLicense: {
    eventAction: 'NNODriverLicense',
  } as Event<string>,
  DriversDefaultValues: {
    eventAction: 'DriversDefaultValues',
  } as Event<string>,
  EnterDriverModalV2: {
    eventAction: 'EnterDriverModalV2',
  } as Event<string>,
  EnterDriverNameVariation: {
    eventAction: 'EnterDriverNameVariation',
  } as Event<string>,
  MaritalStatusSelection: {
    eventAction: 'MaritalStatusSelection',
  } as Event<'Yes' | 'No'>,
  MaritalStatusAddSpouse: {
    eventAction: 'MaritalStatusSpouse',
  } as Event<'Add' | 'Added'>,
  CarsSelectPulledCar: {
    eventAction: 'CarsSelectPulledCar',
  } as Event<''>,
  GenderChanged: {
    eventAction: 'GenderChanged',
  } as Event<string>,
  CoveragePageViewed: {
    eventAction: 'CoveragePageViewed',
  } as Event<string>,
  CoveragePageClicked: {
    eventAction: 'CoveragePageClicked',
  } as Event<string>,
  OnboardingOccupation: {
    eventAction: 'OnboardingOccupation',
  } as Event<string>,
  OnboardingEmailInput: {
    eventAction: 'OnboardingEmailInput',
  } as Event<string>,
  OnboardingPrefillAdditionalInfo: {
    eventAction: 'OnboardingPrefillAdditionalInfo',
  } as Event<string>,
  OnboardingGetCarValue: {
    eventAction: 'OnboardingGetCarValue',
  } as Event<string>,
  OnboardingFullCoverageSubmitted: {
    eventAction: 'OnboardingFullCoverageSubmitted',
  } as Event<string>,
  OnboardingCurrentCoverage: {
    eventAction: 'CurrentCoverage',
  } as Event<string>,
  OnboardingCoveragePreference: {
    eventAction: 'CoveragePreference',
  } as Event<string>,
  OnboardingNetAssets: {
    eventAction: 'NetAssets',
  } as Event<string>,
  OnboardingDeductible: {
    eventAction: 'Deductible',
  } as Event<string>,
  OnboardingAdditionalCoverage: {
    eventAction: 'AdditionalCoverage',
  } as Event<string>,
  OnboardingCustomCoverageChanged: {
    eventAction: 'CustomCoverageChanged',
  } as Event<string>,
  ReshoppingQuestion0: {
    eventAction: 'ReshoppingQuestion0',
  } as Event<'Viewed'>,
  ReshoppingQuestion1: {
    eventAction: 'ReshoppingQuestion1',
  } as Event<'Viewed'>,
  ReshoppingAlertAnswer0: {
    eventAction: 'ReshoppingAlertAnswer0',
  } as Event<string>,
  ReshoppingAlertAnswer1: {
    eventAction: 'ReshoppingAlertAnswer1',
  } as Event<string>,
  MilitaryStatus: {
    eventAction: 'MilitaryStatus',
  } as Event<string>,
};
